module.exports = __webpack_public_path__ + "img/orders-hover.00088fed.svg";